import ProductListingPage from "./ProductListingPageWrapper";

export default ProductListingPage;
